<template>
  <div>
    <nav class="navbar navbar-toggleable-md navbar-inverse bg-inverse">
      <button class=" navbar-toggler " type="button" data-toggle="collapse" data-target="#navbarTogglerDemo01" aria-controls="navbarTogglerDemo01" aria-expanded="false" aria-label="Toggle navigation">
        <span class="navbar-toggler-icon"></span>
      </button>
      <div class="collapse navbar-collapse" id="navbarTogglerDemo01">
        <ul class="navbar-nav mr-auto mt-2 mt-lg-0">
          <li class="nav-item">
            <a class="nav-link" @click.prevent>Modification<span class="sr-only">(current)</span></a>
          </li>
          <li class="nav-item">
            <a class="nav-link" @click.prevent>Dispatch<span class="sr-only">(current)</span></a>
          </li>
          <li class="nav-item">
            <a class="nav-link" @click.prevent>Inspection<span class="sr-only">(current)</span></a>
          </li>
          <li class="nav-item">
            <a class="nav-link" @click.prevent>Purchase order<span class="sr-only">(current)</span></a>
          </li>
          <li class="nav-item">
            <a class="nav-link" @click.prevent>Send to another carrier <span class="sr-only">(current)</span></a>
          </li>
          <li class="nav-item dropdown">
            <a class="nav-link dropdown-toggle" id="navbarDropdownMenuLink" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">Status</a>
              <div class="dropdown-menu" aria-labelledby="navbarDropdownMenuLink">
                <a class="dropdown-item" @click.prevent>Processing</a>
                <a class="dropdown-item" @click.prevent>Dispatched</a>
                <a class="dropdown-item" @click.prevent>Picked</a>
                <a class="dropdown-item" @click.prevent>In transit</a>
                <a class="dropdown-item" @click.prevent>Droped</a>
                <a class="dropdown-item" @click.prevent>pending</a>
                <a class="dropdown-item" @click.prevent>Canceled</a>
                <a class="dropdown-item" @click.prevent>Finished</a>
              </div>
            </li>
        </ul>
        
      </div>
    </nav>
  </div>
</template>

<script>

export default {
  name: 'OrderActionBar',
  data () {
    return {
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  li{
    margin-right: 2rem;
  }
  li.nav-item{
    cursor: pointer;
  }
</style>
